export default "__VITE_ASSET__DQVLFuMp__"